import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

// Importaciones de imágenes
import cmSoltec from "../static/media/marcas/cmsoltec.webp";
import devzone from "../static/media/marcas/devzone.png";
import dr from "../static/media/marcas/dr.webp";
import lilys from "../static/media/marcas/lilys.webp";
import logoMenu from "../static/media/marcas/logo_menu.png";
import matea from "../static/media/marcas/matea.webp";
import yumin from "../static/media/marcas/yumin.png";

const MotionBox = motion(Box);

// Mapeo de marcas con sus respectivas URLs
const brands = [
  { name: "CM Soltec", src: cmSoltec, url: "https://www.cmsoltec.com/" },
  { name: "DevZone", src: devzone, url: "https://devzone-ec.com/" },
  {
    name: "DR Soluciones",
    src: dr,
    url: "https://drsolucionesinformaticas.com/",
  },
  { name: "Lily's Sunflower", src: lilys, url: "https://lilysunflowers.com/" },
  { name: "HydroLuz", src: logoMenu, url: "https://hydroluz.com.ec/" },
  { name: "Marea", src: matea, url: "https://minimarketmarea.com/" },
  { name: "Yumin", src: yumin, url: "#" },
];

export default function BrandsSection() {
  return (
    <Box
      component="section"
      id="marcas"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: "#F8FAFF", // Fondo base de tu UI
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        {/* ─── ENCABEZADO DE LA SECCIÓN ─── */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 750,
              fontSize: { xs: "1.8rem", md: "2.4rem" },
              color: "#1A2B4A",
              lineHeight: 1.15,
            }}
          >
            Marcas que confían en{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg, #2C5FBE 0%, #0EA5E9 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              nuestra tecnología
            </Box>
          </Typography>
        </MotionBox>

        {/* ─── CUADRÍCULA ESTÁTICA DE MARCAS ─── */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 2, sm: 3, md: 4 },
            px: { xs: 1, sm: 2 },
          }}
        >
          {brands.map((brand, i) => (
            <MotionBox
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }} // Aparecen en cascada
              component="a"
              href={brand.url}
              target={brand.url !== "#" ? "_blank" : "_self"}
              rel="noopener noreferrer"
              whileHover={{
                y: -6,
                scale: 1.02,
                boxShadow: "0 20px 40px rgba(13,93,181,0.12)",
              }}
              sx={{
                width: { xs: 130, sm: 160, md: 190 },
                height: { xs: 80, sm: 95, md: 110 },
                bgcolor: "#E8F0FF",
                borderRadius: "20px",
                p: { xs: 2, md: 2.5 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgba(44,95,190,0.12)",
                boxShadow: "0 4px 15px rgba(15,23,42,0.03)",
                cursor: "pointer",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
            >
              <Box
                component="img"
                src={brand.src}
                alt={brand.name}
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  filter:
                    "drop-shadow(0px 2px 4px rgba(0,0,0,0.08)) opacity(0.9)",
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter:
                      "drop-shadow(0px 4px 8px rgba(0,0,0,0.12)) opacity(1)",
                  },
                }}
              />
            </MotionBox>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
